import React from 'react';

export default function MenuIcon (props) {
    return (
        <div className="menu-wrapper">
            <div id="menu" onClick={(e) => props.handleNavBar(e)}>
                <div id="nav-icon2" className={(props.showNavBar) ? 'open' : '' }>
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                    <span />
                </div>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/MenuIcon.js